module.exports = __webpack_public_path__ + "static/media/sponsor_accent.9fa21b7e.svg";